<template>
    <div class="service-supplier-price-details">
        <b-row>
            <b-col cols="12">
                <label>
                    Voci di costo
                </label>
                <b-row class="mt-2 service-supplier-price-details--head">
                    <b-col cols="3">
                        <label>Voce di costo</label>
                    </b-col>
                    <b-col cols="2">
                        <label>Prezzo</label>
                    </b-col>
                    <b-col cols="3">
                        <label>Fornitore</label>
                    </b-col>
                    <b-col cols="2">
                        <label>Quote ID</label>
                    </b-col>
                </b-row>
                <div v-for="(detail,index) in local_supplier_price_details" v-bind:key="_uid+index+local_service_index">
                    <b-row class="mb-2">
                        <b-col cols="3">
                            <b-form-group>
                                <b-form-input
                                    size="sm"
                                    id="voce_di_costo"
                                    placeholder="Voce di costo"
                                    required
                                    :value="detail.label"
                                    @input="(value) => update_supplier_price_detail(index,'label',value)"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2">
                            <b-form-group>
                                <b-form-input
                                    size="sm"
                                    id="price"
                                    placeholder="Prezzo"
                                    required
                                    :value="detail.price"
                                    @input="(value) => update_supplier_price_detail(index,'price',value)"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group>
                                <b-form-input
                                    size="sm"
                                    id="supplier"
                                    placeholder="Fornitore"
                                    required
                                    :value="detail.supplier"
                                    @input="(value) => update_supplier_price_detail(index,'supplier',value)"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2">
                            <b-form-group>
                                <b-form-input
                                    size="sm"
                                    id="supplier_quote_id"
                                    placeholder="Quote ID"
                                    required
                                    :value="detail.supplier_quote_id"
                                    @input="(value) => update_supplier_price_detail(index,'supplier_quote_id',value)"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2">
                            <font-awesome-icon icon="times" @click="remove_supplier_price_detail(index)"/>
                            <font-awesome-icon icon="plus" @click="add_supplier_price_detail"/>
                        </b-col>
                    </b-row>
                </div>
                <div class="text-left" v-if="local_supplier_price_details.length == 0">
                    <font-awesome-icon icon="plus" @click="add_supplier_price_detail"/>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'service-supplier-price-details',
    components: {
    },
    props: {
        supplier_price_details: Array,
        service_index: Number,
    },
    data() {
        return {
            local_supplier_price_details: [...this.supplier_price_details],
            local_service_index: this.service_index,
        }
    },
    created()
    {
    },
    mounted() {
        if(this.local_supplier_price_details.length == 0)
        {
            this.add_supplier_price_detail()
        }
    },
    methods:{
        add_supplier_price_detail()
        {
            this.local_supplier_price_details.push({
                label: '',
                price: 0,
                supplier: '',
                supplier_quote_id: ''
            })
        },
        remove_supplier_price_detail(index)
        {
            this.local_supplier_price_details.splice(index, 1)
        },
        update_supplier_price_detail(index,key,value)
        {
            this.local_supplier_price_details[index][key] = value
            this.$emit('supplier_price_details_updated',this.local_supplier_price_details)
        }
    },
}
</script>

<style lang="scss">
    .service-supplier-price-details
    {
        &--head
        {
            label
            {
                color:$gray-600;
                font-size:11px;
                font-weight: normal;
                font-style: italic;
            }
        }
    }
</style>